export default __webpack_public_path__ + "static/media/carousel-foto.32a19199.jpg";